import { render, staticRenderFns } from "./BaseUpComming.vue?vue&type=template&id=08eb2f38&scoped=true&"
import script from "./BaseUpComming.vue?vue&type=script&lang=js&"
export * from "./BaseUpComming.vue?vue&type=script&lang=js&"
import style0 from "./BaseUpComming.vue?vue&type=style&index=0&id=08eb2f38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb2f38",
  null
  
)

export default component.exports